import axios from "axios";
import {
  ButtonHeaderWrapper,
  FolderContainer,
  SearchBar,
  Table,
  ToggleButton,
  Button,
} from "globalComponents";
import ExportCSV from "globalComponents/ExportCSV";
import { errorHandler } from "globalResources/util";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addNotification } from "store/slices/uiSlice";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import CreateClientModal from "./components/CreateClientModal";

const headers = [
  {
    label: "Name",
    sortBy: "name",
    render: (row) => <div>{row.name}</div>,
  },
  { label: "Description", render: (row) => <div>{row.description}</div> },
  { label: "Pay Period End", render: (row) => <div>{row.reportDay}</div> },
  {
    label: "Pay Group",
    render: (row) => <div>{row?.payGroup ? row.payGroup : ""}</div>,
  },
];

const Main = styled.div`
  display: flex;
  flex-direction: column;
`;

const FilterBar = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 5px;
  gap: 20px;
  flex-wrap: wrap;
`;

const Clients = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const cachedFilters = location?.state?.cachedFilters
    ? location.state.cachedFilters
    : null;

  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [create, setCreate] = useState(false);
  const [search, setSearch] = useState(
    cachedFilters ? cachedFilters.search : "",
  );
  const [archived, setArchived] = useState(
    cachedFilters ? cachedFilters.archived : false,
  );
  const [pagination, setPagination] = useState(
    cachedFilters
      ? cachedFilters.pagination
      : {
          page: 1,
          limit: 20,
          direction: 1,
          total: 0,
        },
  );
  const history = useHistory();

  const createParam = new URLSearchParams(history.location.search).get(
    "create",
  );
  useEffect(() => {
    if (createParam === "true") {
      setCreate(true);
    }
  }, [createParam]);

  const fetchClients = () => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/clients`, {
        params: {
          search: search,
          page: pagination.page,
          limit: pagination.limit,
          direction: pagination.direction,
          archived: archived,
        },
      })
      .then(async (res) => {
        setClients(res.data.clients);
        setPagination((old) => ({ ...old, total: res.data.total }));
      })
      .catch((err) => {
        const { message } = errorHandler(err);
        dispatch(addNotification({type: "error", message }));
      })
      .finally(() => setLoading(false));
  };

  const format4CSV = () => {
    let ans = [];
    clients.forEach((row) => {
      ans.push({
        name: row.name,
        description: row.description,
        payPeriod: row.reportDay,
        payGroup: row.payGroup,
      });
    });
    return ans;
  };
  useEffect(() => {
    fetchClients();
  }, [
    pagination.direction,
    pagination.limit,
    pagination.page,
    archived,
    search,
  ]);
  return (
    <FolderContainer title="Clients">
      <ButtonHeaderWrapper>
        <ExportCSV data={format4CSV()} filename="users" />
        <Button onClick={() => setCreate(true)}>Add Client</Button>
      </ButtonHeaderWrapper>
      <Main>
        <FilterBar>
          <SearchBar
            style={{
              width: "50%",
              margin: "auto",
            }}
            onSearch={(v) => setSearch(v)}
            search={search}
          />
          <ToggleButton
            label="Show Disabled"
            onChange={() => setArchived(!archived)}
            value={archived}
          />
        </FilterBar>
        <Table
          data={clients}
          loading={loading}
          headers={headers}
          pagination={pagination}
          onClick={(row) =>
            history.push({
              pathname: `/client/${row._id}/details`,
              state: { cachedFilters: { pagination, search, archived } },
            })
          }
          onPage={(page) => setPagination((old) => ({ ...old, page }))}
          onLimit={(limit) => {
            setPagination((old) => ({ ...old, limit }));
          }}
          sortBy={"name"}
          sortDirection={pagination.direction}
          onSort={(by, direction) => setPagination((old) => ({ direction }))}
        />
      </Main>
      {create && <CreateClientModal onClose={() => setCreate(false)} />}
    </FolderContainer>
  );
};
export default Clients;
